import { render, staticRenderFns } from "./template.vue?vue&type=template&id=726475fe&scoped=true&"
import script from "@/Components/Global/LoginHeader/component.ts?vue&type=script&lang=ts&"
export * from "@/Components/Global/LoginHeader/component.ts?vue&type=script&lang=ts&"
import style0 from "@/Components/Global/LoginHeader/style.scss?vue&type=style&index=0&id=726475fe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "726475fe",
  null
  
)

export default component.exports